import React, { useCallback } from 'react';
import { Form, Field } from 'react-final-form';
import pageIconSrc from '../../../src/assets/images/selfie-circle.svg';
import arrowLeftSrc from '../../../src/assets/images/arrow-left.svg';
import IndexLink from '../partials/IndexLink';
import { ReactSVG } from 'react-svg';
import {
  messagesSelector,
  currentThemeSelector,
  identityDocumentStatusSelector
} from '../../helpers/selectors';
import { connect } from 'react-redux';
import { getMessage as t } from '../../utils/utils';
import classnames from 'classnames';
import { documentPresent } from '../../helpers/components';
import { PureFileField } from './fields/file';
import { DOCUMENT_STATUS } from '../../constants/backend';
/**
 * @typedef {object} SelfieFormProps
 * @property {boolean} [isSubscribePage=false]
 */
function SelfieForm({
  onSubmit,
  initialValues,
  isSubscribePage = false,
  m,
  userDataUpdating,
  hideFileUpload,
  theme,
  identityDocumentStatus
}) {
  const { selfie } = theme.icons || {};
  const identityDocumentApproved =
    identityDocumentStatus === DOCUMENT_STATUS.APPROVED;
  const readOnlyForm = !isSubscribePage && identityDocumentApproved;
  const validate = useCallback(
    (values = {}) => {
      if (!hideFileUpload && !documentPresent(values.selfieImage)) {
        return { selfieImage: true };
      }
      return {};
    },
    [hideFileUpload]
  );

  return (
    <Form onSubmit={onSubmit} initialValues={initialValues} validate={validate}>
      {({ handleSubmit }) => (
        <form className="selfie-page" onSubmit={handleSubmit} noValidate>
          <div className="scope-content-header">
            <img
              className="scope-content-header-picture"
              src={selfie ? selfie : pageIconSrc}
              alt="page icon"
            />
            <div className="scope-content-header-title-container">
              {!isSubscribePage && (
                <IndexLink to="/profile" className="scope-content-header-button-return">
                  <ReactSVG className="react-svg" src={arrowLeftSrc} />
                </IndexLink>
              )}
              <div className="scope-content-header-title">
                {t(m, 'profile.section.selfie')}
              </div>
            </div>
          </div>
          <div className="scope-content-body">
            <div className="scope-section">
              <div className="scope-section-fields">
                {hideFileUpload ? (
                  <div className="scope-field-container">
                    <div className="scope-info-text">
                      {t(m, 'label.file.upload.only.mobile')}
                    </div>
                  </div>
                ) : (
                  <div className="scope-field-container">
                    <div className="scope-info-text">
                      {t(m, 'profile.selfie.section.info')}
                    </div>
                  </div>
                )}
                {!hideFileUpload && (
                  <Field
                    name="selfieImage"
                    label={t(m, 'label.identity_card_selfie')}
                    mandatory
                    disabled={readOnlyForm}
                    component={PureFileField}
                  />
                )}
              </div>
            </div>
          </div>
          {!hideFileUpload && (
            <div className="scope-content-footer">
              {!readOnlyForm && (
                <button
                  type="submit"
                  className={classnames('scope-submit-button', 'primary-btn', {
                    'sub-class-disabled': userDataUpdating
                  })}
                >
                  {isSubscribePage ? t(m, 'generic.next') : t(m, 'generic.save')}
                </button>
              )}
            </div>
          )}
        </form>
      )}
    </Form>
  );
}
const mapStateToProps = (state) => {
  const { userDataUpdating } = state.user;

  return {
    m: messagesSelector(state),
    userDataUpdating,
    identityDocumentStatus: identityDocumentStatusSelector(state),
    theme: currentThemeSelector(state)
  };
};

export default connect(mapStateToProps)(SelfieForm);
